<template>
  <div class="tag">
    <div v-if="path == 'addorder'">
      <!--isbuygift 前端自建参数-->
      <img class="gift" src="../../assets/images/zeng1.png" v-if="goods.isgift == 1 || goods.isbuygift == 1 || goods.isgiftproduct == 1" />
      <img class="gift" src="../../assets/images/stock.png" v-else-if="dataObj.isprogift == 1" />
      <img class="gift" src="/static/images/changebuy/change.png" v-else-if="goods.ischangebuy == 1" />
      <img class="gift" src="/static/images/changebuy/add@2x.png" v-else-if="goods.isexchangebuy == 1" />
      <img class="gift" src="/static/images/other/gift@2x.png" v-else-if="goods.is_subscribegoods == 1" />
    </div>
    <!--
    --addOrder--
    --cart_pro_item.vue
    <img class="gift" v-if="goods.isgift == 1 || goods.isgiftproduct == 1" src="../../assets/images/zeng1.png">
    <img class="gift" v-if="dataObj.isprogift == 1" src="../../assets/images/stock.png">
    <img class="gift" v-if="goods.ischangebuy == 1" src="/static/images/changebuy/change.png">
    <img class="gift" v-if="goods.isexchangebuy == 1" src="/static/images/changebuy/add@2x.png">
    -->
    <div v-else>
      <img class="gift" src="/static/images/other/change-icon.png" v-if="goods.isadditem == 1" />
      <img class="gift" src="../../assets/images/zeng1.png" v-else-if="goods.isgift == 1" />
      <img class="zeng" src="../../assets/images/stock.png" v-else-if="goods.isprogift == 1" />
      <img class="zeng" src="../../assets/images/yu.png" v-else-if="!goods.ischangebuy && goods.ispresale == 1" />
      <img class="both" src="/static/images/changebuy/both.png" v-else-if="goods.ischangebuy && goods.ispresale == 1" />
      <img class="both" src="/static/images/changebuy/both-add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 1" />
      <img class="both" src="/static/images/changebuy/both-gift.png" v-else-if="goods.isgift == 1 && goods.ispresale == 1" />
      <img class="gift" src="/static/images/changebuy/change.png" v-else-if="goods.ischangebuy && goods.ispresale == 0" />
      <img class="zeng" src="/static/images/changebuy/add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 0" />
      <img class="group" src="/static/wx/img/new-group/itemcollage.png" v-else-if="goods.is_group_act == 1" />
      <img class="gift" src="/static/images/other/gift@2x.png" v-else-if="goods.is_subscribegoods == 1" />
    </div>
    <!--
    --myorder-order--
    <img v-if="goods.isadditem == 1" class="zeng" src="/static/images/other/change-icon.png">
    <img v-else-if="goods.isgift == 1" class="zeng" src="../../assets/images/zeng1.png">
    <img v-else-if="goods.isprogift == 1" class="zeng" src="../../assets/images/stock.png">
    <img v-else-if="!goods.ischangebuy && goods.ispresale == 1" class="zeng" src="../../assets/images/yu.png">
    <img v-else-if="goods.ischangebuy && goods.ispresale == 1" class="add both" src="/static/images/changebuy/both.png">
    <img v-else-if="goods.isexchangebuy && goods.ispresale == 1" class="add both" src="/static/images/changebuy/both-add@2x.png">
    <img v-else-if="goods.ischangebuy && goods.ispresale == 0" class="zeng" src="/static/images/changebuy/change.png">
    <img v-else-if="goods.isexchangebuy && goods.ispresale == 0" class="zeng" src="/static/images/changebuy/add@2x.png">
    <img v-else-if="goods.is_group_act == 1" class="gift group" src="/static/wx/img/new-group/itemcollage.png">

    --myorder-refund--
    <img v-if="goods.isadditem == 1" class="add" src='/static/images/other/change-icon.png'>
    <img v-else-if="goods.isgift == 1" class="zeng" src="../../assets/images/zeng1.png">
    <img v-else-if="goods.isprogift == 1" class="add" src="../../assets/images/stock.png">
    <img v-else-if="!goods.ischangebuy && goods.ispresale == 1" class="add" src="../../assets/images/yu.png">
    <img v-else-if="goods.ischangebuy && goods.ispresale == 1" class="add both" src="/static/images/changebuy/both.png">
    <img v-else-if="goods.isexchangebuy && goods.ispresale == 1" class="add both" src="/static/images/changebuy/both-add@2x.png">
    <img v-else-if="goods.ischangebuy && goods.ispresale == 0" class="add" src="/static/images/changebuy/change.png">
    <img v-else-if="goods.isexchangebuy && goods.ispresale == 0" class="add" src="/static/images/changebuy/add@2x.png">
    <img v-else-if="goods.is_group_act == 1" class="zeng group" src="/static/wx/img/new-group/itemcollage.png">

    --orderDetails--
    <img v-if="goods.isadditem == 1" class="zeng" src='/static/images/other/change-icon.png'>
    <img class="zeng" src="../../assets/images/zeng1.png" v-else-if="goods.isgift == 1">
    <img class="zeng" src="../../assets/images/stock.png" v-else-if="goods.isprogift == 1">
    <img class="add both" src="/static/images/changebuy/both.png" v-else-if="goods.ischangebuy && goods.ispresale == 1">
    <img class="add both" src="/static/images/changebuy/both-add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 1">
    <img class="zeng" src="/static/images/changebuy/change.png" v-else-if="goods.ischangebuy && goods.ispresale == 0">
    <img class="zeng" src="/static/images/changebuy/add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 0">
    <img class="zeng group" src="/static/wx/img/new-group/itemcollage.png" v-else-if="goods.is_group_act == 1">

    --splitDetails--
    <img class="zeng" v-if="goods.isgift == 1" src="../../assets/images/zeng1.png">
    <img v-else-if="goods.isprogift == 1" class="zeng" src="../../assets/images/stock.png">
    <img v-else-if="goods.is_group_act == 1" class="zeng group" src="/static/wx/img/new-group/itemcollage.png">

    --orderSearchList--
    <img v-if="goods.isadditem == 1" class="zeng" src='/static/images/other/change-icon.png'>
    <img v-else-if="goods.isgift == 1" class="zeng" src="../../assets/images/zeng1.png">
    <img v-else-if="goods.isprogift == 1" class="zeng" src="../../assets/images/stock.png">
    <img v-else-if="!goods.ischangebuy && goods.ispresale == 1" class="zeng" src="../../assets/images/yu.png">
    <img v-else-if="goods.ischangebuy && goods.ispresale == 1" class="add both" src="/static/images/changebuy/both.png">
    <img v-else-if="goods.isexchangebuy && goods.ispresale == 1" class="add both" src="/static/images/changebuy/both-add@2x.png">
    <img v-else-if="goods.ischangebuy && goods.ispresale == 0" class="zeng" src="/static/images/changebuy/change.png">
    <img v-else-if="goods.isexchangebuy && goods.ispresale == 0" class="zeng" src="/static/images/changebuy/add@2x.png">
    <img v-else-if="goods.is_group_act == 1" class="zeng group" src="/static/wx/img/new-group/itemcollage.png">

    --afterDetails--
    <img class="gift" src='/static/images/other/change-icon.png' v-if="goods.isadditem == 1">
    <img class="gift" src="../../assets/images/zeng1.png" v-else-if="goods.isgift == 1">
    <img class="zeng" src="../../assets/images/stock.png" v-else-if="goods.isprogift == 1">
    <img class="add both" src="/static/images/changebuy/both.png" v-else-if="goods.ischangebuy && goods.ispresale == 1">
    <img class="add both" src="/static/images/changebuy/both-add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 1">
    <img class="gift" src="/static/images/changebuy/change.png" v-else-if="goods.ischangebuy && goods.ispresale == 0">
    <img class="zeng" src="/static/images/changebuy/add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 0">
    <img class="gift group" src="/static/wx/img/new-group/itemcollage.png" v-else-if="goods.is_group_act == 1">

    --refundSalesReturn--
    <img class="gift" src='/static/images/other/change-icon.png' v-if="goods.isadditem == 1">
    <img class="gift" src="../../assets/images/zeng1.png" v-else-if="goods.isgift == 1">
    <img class="zeng" src="../../assets/images/stock.png" v-else-if="goods.isprogift == 1">
    <img class="add both" src="/static/images/changebuy/both.png" v-else-if="goods.ischangebuy && goods.ispresale == 1">
    <img class="add both" src="/static/images/changebuy/both-add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 1">
    <img class="gift" src="/static/images/changebuy/change.png" v-else-if="goods.ischangebuy && goods.ispresale == 0">
    <img class="zeng" src="/static/images/changebuy/add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 0">
    <img class="gift group" src="/static/wx/img/new-group/itemcollage.png" v-else-if="goods.is_group_act == 1">

    --salesReturn--
    <img class="gift" src='/static/images/other/change-icon.png' v-if="goods.isadditem == 1">
    <img class="gift" src="../../assets/images/zeng1.png" v-else-if="goods.isgift == 1">
    <img class="zeng" src="../../assets/images/stock.png" v-else-if="goods.isprogift == 1">
    <img class="add both" src="/static/images/changebuy/both.png" v-else-if="goods.ischangebuy && goods.ispresale == 1">
    <img class="add both" src="/static/images/changebuy/both-add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 1">
    <img class="gift" src="/static/images/changebuy/change.png" v-else-if="goods.ischangebuy && goods.ispresale == 0">
    <img class="zeng" src="/static/images/changebuy/add@2x.png" v-else-if="goods.isexchangebuy && goods.ispresale == 0">
    <img class="gift group" src="/static/wx/img/new-group/itemcollage.png" v-else-if="goods.is_group_act == 1">
    -->
  </div>
</template>

<script>
export default {
  name: 'goodsTag',
  props: {
    goods: {
      type: Object,
      default: function () {
        return {}
      }
    },
    dataObj: {
      type: Object,
      default: function () {
        return {}
      }
    },
    path: {
      type: String,
      default: '' // 默认为订单类页面路径
    }
  }
}
</script>

<style scoped lang="scss">
.tag {
  position: absolute;
  right: 0;
  top: 0;
  .gift {
    width: 0.28rem;
    height: 0.28rem;
  }
  .zeng {
    width: 0.23rem;
    height: 0.23rem;
  }
  .group {
    width: 0.24rem;
    height: 0.15rem;
  }
  .add {
    width: 0.23rem;
    height: 0.23rem;
  }
  .both {
    width: 0.26rem;
    height: 0.13rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/goodsTag.vue